import AllianceOverviewMap from "@/components/allianceDemo/AllianceOverviewMap";

export default [
  {
    path: "/alliance",
    name: "AllianceOverviewMap",
    component: AllianceOverviewMap,
    meta: {
      requiresAuthentication: true
    }
  }
];
